import PropTypes from "prop-types";
import { useState } from "react";
import {
  Radio,
  RadioGroup,
  FormControlLabel,
  Card,
  Divider,
} from "@mui/material";
import MDBox from "theme/components/MDBox";
import MDTypography from "theme/components/MDTypography";

function RadioButtonGroupField({ displayName, fieldRef, options }) {
  const [value, setValue] = useState("");

  return (
    <MDBox>
      <MDBox mb={1}>
        <MDTypography variant="h6" fontSize={14} fontWeight="light">
          {displayName}
        </MDTypography>
      </MDBox>

      <MDBox mb={1}>
        <Divider />
      </MDBox>

      <RadioGroup value={value} onChange={(e) => setValue(e.target.value)}>
        {options?.map((opt) => (
          <FormControlLabel
            key={opt.value}
            value={opt.value}
            control={<Radio />}
            label={opt.name}
          />
        ))}
      </RadioGroup>

      <input
        type="hidden"
        id={`dff_${fieldRef}`}
        name={fieldRef}
        value={value}
      />
    </MDBox>
  );
}

// Typechecking props
RadioButtonGroupField.propTypes = {
  fieldRef: PropTypes.string.isRequired,
  displayName: PropTypes.string.isRequired,
  options: PropTypes.arrayOf(PropTypes.object),
};

RadioButtonGroupField.defaultProps = {
  options: [],
};

export default RadioButtonGroupField;
